import React from "react";
import styled from "@emotion/styled";
import { WarningOutlined } from "@ant-design/icons";
import { useLocation } from "react-router-dom";
import { isAdminPage } from "../config/admin";

const Banner = styled.div`
  width: 100%;
  background-color: #fffbe6;
  border: none;
  padding: 8px 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: normal;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.65);
  z-index: 1000;
  position: fixed;
  bottom: 0;
  left: 0;
`;

const StyledIcon = styled(WarningOutlined)`
  margin-right: 8px;
  font-size: 14px;
  color: #faad14;
`;

export const AdminBanner: React.FC = () => {
  const { pathname } = useLocation();

  if (!isAdminPage(pathname)) {
    return null;
  }

  return (
    <Banner>
      <StyledIcon />
      You are currently viewing an admin page. Changes made here will impact all
      users.
    </Banner>
  );
};
